
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import { JsonLdReview } from '@components/config/SEO';
import Drivers from '@pages/drivers/Drivers';
import { NextSeo } from 'next-seo';

export default function Index() {
  return (
    <div>
      <NextSeo
        title="Private Hire Driving Jobs Birmingham | 247 Radio Carz"
        description="Join 247 Radio Carz and become part of an exclusive group of drivers with the freedom to choose their own schedule and earn top-notch hourly rates.Get on board today for an enriching career experience."
        keywords="taxi driver, taxi driver job, drivers, hackney driver, private hire driver, taxi licensing, drive for 247 Radio Cars, driver jobs birmingham, birmingham taxi, birmingham taxis, local taxis"
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/become-a-driver',
        }}
        canonical="https://www.247radiocarz.co.uk/become-a-driver"
      />
      <JsonLdReview />
      <Drivers />
    </div>
  );
}
